/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedules_Awaiting_Approval_HintInputs */



/**
* | output |
* | --- |
* | "Further runs are skipped until these are approved." |
*
* @param {Agent_Schedules_Awaiting_Approval_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedules_awaiting_approval_hint = /** @type {((inputs?: Agent_Schedules_Awaiting_Approval_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedules_Awaiting_Approval_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Weitere Läufe werden übersprungen, bis diese freigegeben sind.")
	return /** @type {LocalizedString} */ ("Further runs are skipped until these are approved.")
});